
class Socket {
	constructor(url,options = {}) {
		const {
			onOpen,
		} = options;
		this.ws = null;
		this.wsUrl = url;
		this.openCallback = onOpen || (() => {});
		this.messageCallBack = null;
		this.isOpen = false; // 是否连接
		this.pingIntervalSeconds = 3000;// 心跳连接时间
		this.lockReconnect = false;// 是否真正建立连接
		this.heartTimer = null; // 心跳定时器
		this.serverTimer = null; // 服务器超时 定时器
		this.reconnectTimer = null; // 断开 重连倒计时
		this.sendFixHeartTimer = null; //20s固定发送心跳定时器
		this.connect();
	}

	connect() {
		this.ws = uni.connectSocket({
			url: this.wsUrl,
			complete: () => {}
		});

		// ws连接成功
		this.ws.onOpen(this.open.bind(this)) //bind(this,this.open)();

		// ws收到服务器消息
		this.ws.onMessage(this.onMessage.bind(this));

		// 错误
		this.ws.onError((e) => {
			//重连
			this.reconnect();
		})

		// 关闭
		this.ws.onClose((res) => {
			if (res.code != 1000) {
				//重连
				this.reconnect();
			}
		});
	}

	open(e) {
		console.log('连接成功', e)
		//开启心跳
		// this.start();
		this.sendFixHeart();
		this.openCallback();
		uni.$emit('WS_OPEN');
	}
	
	onMessage(e){
		if(typeof e.data === 'string' && /pong/.test(e.data)) return;

		const finish = (wsData) => {
			if (wsData) uni.$emit('WS_MESSAGE', wsData);
			this.messageCallBack && this.messageCallBack(e);
		};

		const decodeBytes = (raw) => {
			const bytes = raw instanceof Uint8Array ? raw : new Uint8Array(raw);
			const pako = uni.$pako || (typeof window !== 'undefined' ? window.pako : null);
			if (!pako) throw new Error('pako missing');
			// 与 stock_web 一致：先 inflate，gzip 再走 ungzip
			if (typeof pako.inflate === 'function') {
				try {
					return pako.inflate(bytes, { to: 'string' });
				} catch (err) {}
			}
			return pako.ungzip(bytes, { to: 'string' });
		};

		const parseWsData = (result) => {
			const wsData = typeof result === 'string' ? JSON.parse(result) : result;
			wsData.data = typeof wsData.data === 'object' ? wsData.data : JSON.parse(wsData.data);
			return wsData;
		};

		try {
			if (typeof e.data === 'string') {
				finish(parseWsData(e.data));
				return;
			}
			if (typeof Blob !== 'undefined' && e.data instanceof Blob) {
				e.data.arrayBuffer().then((buf) => {
					try {
						finish(parseWsData(decodeBytes(buf)));
					} catch (err) {
						console.log(err);
						finish();
					}
				}).catch((err) => {
					console.log(err);
					finish();
				});
				return;
			}
			finish(parseWsData(decodeBytes(e.data)));
		} catch (err) {
			console.log(err);
			finish();
		}
	}

	send(data) {
		this.ws.send({ data });
	}

	reconnect() {
		//设置lockReconnect变量避免重复连接
		if (this.lockReconnect) return;
		this.lockReconnect = true;
		this.reconnectTimer && clearTimeout(this.reconnectTimer);
		this.reconnectTimer = setTimeout(() => {
			this.connect();
			this.lockReconnect = false;
		}, parseInt(Math.random() * 2000 + 3000));
	}

	// 开启心跳
	start() {
		this.heartTimer && clearTimeout(this.heartTimer);
		this.serverTimer && clearTimeout(this.serverTimer);
		this.heartTimer = setTimeout(() => {
			this.send(JSON.stringify({
				ping: new Date().getTime()
			}));
			//超时关闭，超时时间为5s
			this.serverTimer = setTimeout(() => {
				this.ws.close();
			}, 5000);
		}, this.pingIntervalSeconds)
	}

	// 重置心跳
	reset() {
		clearTimeout(this.heartTimer);
		clearTimeout(this.serverTimer);
		this.start();
	}
	
	// 固定发送心跳
	sendFixHeart() {
		clearInterval(this.sendFixHeartTimer);
		this.sendFixHeartTimer = setInterval(() => {
			this.send(JSON.stringify({
				ping: new Date().getTime()
			}));
		}, 15 * 1000);
	}
}

export default Socket;